import { render, staticRenderFns } from "./PayTitle.vue?vue&type=template&id=889cf084&scoped=true"
import script from "./PayTitle.vue?vue&type=script&lang=js"
export * from "./PayTitle.vue?vue&type=script&lang=js"
import style0 from "./PayTitle.vue?vue&type=style&index=0&id=889cf084&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "889cf084",
  null
  
)

export default component.exports